var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"three-dim-multipal-player",staticStyle:{"width":"100%","height":"100%","display":"flex","flex-flow":"row wrap"}},[_c('div',{staticClass:"forVideo",style:("width:100%;height: 100%;display:flex;flex-wrap:wrap")})])}
var staticRenderFns = []

export { render, staticRenderFns }